/**
 * Rule-of-thirds grid over the viewfinder (SPEC_STAMP_ROUND_20260924 §D): 1 px lines at 40 %
 * opacity, decorative (aria-hidden), premises stills only. The lines scale with the viewfinder
 * (a 3×3 viewBox stretched to the box; `non-scaling-stroke` keeps them 1 px).
 */
export function GridOverlay(): JSX.Element {
  return (
    <svg className="sv-grid" data-testid="grid-overlay" viewBox="0 0 3 3" preserveAspectRatio="none" aria-hidden="true">
      <title>grid</title>
      <line x1="1" y1="0" x2="1" y2="3" />
      <line x1="2" y1="0" x2="2" y2="3" />
      <line x1="0" y1="1" x2="3" y2="1" />
      <line x1="0" y1="2" x2="3" y2="2" />
    </svg>
  );
}
